module.exports = __webpack_public_path__ + "img/frxxbg2.9590c750.png";